<template>
  <section>
    <form class="topup-form" @submit.prevent="submit">
      <div class="topup-form-frame">
        <div>
          <h1 class="step-title" v-html="$t('component.autotopup.stage2.title')"></h1>
          <h2 class="dark-title" v-if="!canShowContacts" v-html="$t('component.autotopup.stage2.headerNoContacts')"></h2>
          <h2 class="dark-title" v-if="canShowContacts" v-html="$t('component.autotopup.stage2.header1')"></h2>
          <div v-if="canShowContacts" class="topup-contacts">
            <ul class="topup-contacts-list">
              <li v-for="(contact, index) in contacts"
                  @click="toggleContact(contact)"
                  @keydown.space.prevent="toggleContact(contact)"
                  :key="index"
                  tabindex="0"
                  :title="isContactActive(contact.msisdn) ? $t('component.stage1.a11y.unselectNumberButton') : $t('component.stage1.a11y.chooseNumberButton')"
                  class="topup-contacts-item"
                  :class="{
                  checking: isContactChecking(contact.msisdn),
                  active: isContactActive(contact.msisdn),
                  error: isContactError(contact.msisdn)
                }">
                <div>
                  <i class="item-icon el-icon-user-solid"></i>
                  <div class="item-name">{{ contact.description | truncate(20) }}</div>
                  <div class="item-number">({{ contact.msisdn | phone }})</div>
                  <i class="info el-icon-check"
                     v-if="isContactActive(contact.msisdn) && !isContactChecking(contact.msisdn)"></i>
                  <el-tooltip :content="$t('component.autotopup.stage2.contactCheckphoneError')"
                              placement="top"
                              v-if="isContactError(contact.msisdn)">
                    <i class="info el-icon-warning"></i>
                  </el-tooltip>
                </div>
              </li>
            </ul>
          </div>
          <h2 class="dark-title" v-if="canShowContacts" v-html="$t('component.autotopup.stage2.header2')"></h2>
          <div class="topup-form-fields">
            <div>
              <section class="topup-form-field-zone no-margin-bottom">
                <div class="topup-form-field">
                  <div class="topup-form-field-container" :class="{error: (formErrors && isPhoneError) || isCheckPhoneError}">
                    <label :for="'form-phone'">{{ $t('component.autotopup.stage2.labelPhone') }} *</label>
                    <input type="text"
                           :id="'form-phone'"
                           class="topup-phone"
                           ref="topupPhoneInput"
                           v-model.trim="form.phone"
                           data-matomo-unmask
                           :disabled="isCheckPhoneInProgress || isAnyContactSet"
                           autocomplete="tel"
                           @keyup="checkPhone(form.phone)"
                           @paste="checkPhoneOnPaste($event)"
                           v-mask="'###-###-###'"
                           placeholder="___-___-___">
                    <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="isCheckPhoneInProgress"/>
                  </div>
                  <div class="topup-form-error-container phone-error" v-if="(formErrors && isPhoneError) || isCheckPhoneError">
                    <ul>
                      <li v-if="isPhoneEmpty">{{ $t('component.autotopup.stage2.errorPhoneRequired') }}</li>
                      <li v-if="isPhoneInvalid">{{ $t('component.autotopup.stage2.errorPhoneInvalid') }}</li>
                      <li v-if="isCheckPhoneError">{{ $t('component.autotopup.stage2.errorPhoneCheck') }}</li>
                      <li v-if="isPhoneAutotopupActive">{{ $t('component.autotopup.stage2.errorPhoneAutotopupActive') }}</li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
            <div>
              <section class="topup-form-field-zone no-margin-bottom">
                <div class="topup-form-field">
                  <div class="topup-form-field-container" :class="{error: formErrors && isNameError}">
                    <label for="form-name">{{ $t('component.autotopup.stage2.labelName') }} *</label>
                    <input type="text"
                           id="form-name"
                           autocomplete="name"
                           v-model.trim="form.name"
                           maxlength="30"
                           :disabled="isAnyContactSet">
                  </div>
                  <div class="topup-form-error-container email-error" v-if="formErrors && isNameError">
                    <ul>
                      <li>{{ $t('component.autotopup.stage2.errorNameRequired') }}</li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div class="topup-form-buttons">
        <button id="go-back-step-2"
                type="button"
                @click="goBack"
                :title="$t('component.autotopup.stage2.a11y.toPreviousStepButton')">
          ‹ {{ $t('component.autotopup.stage2.buttonBack') }}
        </button>
        <button type="submit"
                :disabled="isSubmitButtonDisabled"
                id="submit-step-1"
                :title="$t('component.autotopup.stage2.a11y.toNextStepButton')">
          {{ $t('component.autotopup.stage2.buttonNext') }} ›
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import Stage2Mixin from '@/common/mixins/Topup/Auto/Stage2.mixin'

export default {
  name: 'TopupAutoStage2',
  mixins: [Stage2Mixin]
}
</script>

<style src="../../../assets/scss/topup-form.scss" lang="scss"></style>
